import QtdModulo from '../../ModulosCrefito/QtdModulo'
import TOregistroProntuario from '../../ModulosCrefito/ModulosTO/TOregistroProntuario'
import TOestagio from '../../ModulosCrefito/ModulosTO/TOestagio'
import TOoutrosDados from '../../ModulosCrefito/ModulosTO/TOoutrosDados'
import TOorientacoes from '../../ModulosCrefito/ModulosTO/TOorientacoes'
import TOresponsavelFisc from '../../ModulosCrefito/ModulosTO/TOresponsavelFisc'
import TOprofissionaisNoEstabelecimento from '../../ModulosCrefito/ModulosTO/TOprofissionaisNoEstabelecimento'
import TOuti from '../../ModulosCrefito/ModulosTO/TOuti'
import TOucin from '../../ModulosCrefito/ModulosTO/TOucin'
import TOenfermaria from '../../ModulosCrefito/Modulos/TOenfermaria'
import TOambulatorio from '../../ModulosCrefito/ModulosTO/TOambulatorio'
import TOresidencia from '../../ModulosCrefito/ModulosTO/TOresidencia'
import TOrecursoEstrutura from '../../ModulosCrefito/ModulosTO/TOrecursoEstrutura'
import TOoutrasUnidades from '../../ModulosCrefito/ModulosTO/TOoutrasUnidades'
import TOexposicaoprofissional from '../../ModulosCrefito/ModulosTO/TOexposicaoprofissional'
import TOintervencoes from '../../ModulosCrefito/ModulosTO/TOintervencoes'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const Hospital = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="RESPONSÁVEL PELO RECEBIMENTO DA FISCALIZAÇÃO" modulo="toresponsavelfisc" />
            <TOresponsavelFisc modulo="toresponsavelfisc" />
            <QtdModulo texto="PROFISSIONAIS TERAPEUTAS OCUPACIONAIS" modulo="toprofissionaisnoestabelecimento" />
            <TOprofissionaisNoEstabelecimento modulo="toprofissionaisnoestabelecimento" />
            <QtdModulo texto="SETORES DA ASSISTÊNCIA - RECURSOS E ESTRUTA " modulo="torecursoest" />
            <TOrecursoEstrutura modulo="torecursoest" />
            <QtdModulo texto="UTI" modulo="touti" />
            <TOuti modulo="touti" />
            <QtdModulo texto="UCIN" modulo="toucin" />
            <TOucin modulo="toucin" />
            <QtdModulo texto="OUTRAS UNIDADES DE TERAPIA" modulo="tooutrasunidades" />
            <TOoutrasUnidades modulo="tooutrasunidades" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="toregistroprontuario" />
            <TOregistroProntuario modulo="toregistroprontuario" />
            <QtdModulo texto="ENFERMARIA" modulo="toenfermaria" />
            <TOenfermaria modulo="toenfermaria" />
            <QtdModulo texto="AMBULATÓRIO" modulo="toambulatorio" />
            <TOambulatorio modulo="toambulatorio" />
            <QtdModulo texto="ESTÁGIO" modulo="toestagio" />
            <TOestagio modulo="toestagio" />
            <QtdModulo texto="PROGRAMA DE RESIDÊNCIA" modulo="toresidencia" />
            <TOresidencia modulo="toresidencia" />
            <QtdModulo texto="EXPOSIÇÃO DOS PROFISSIONAIS A DOENÇAS INFECTO-CONTAGIOSAS " modulo="toexposicao" />
            <TOexposicaoprofissional modulo="toexposicao" />
            <QtdModulo texto="INTERVENÇÕES DA TERAPIA OCUPACIONAL " modulo="tointervencoes" />
            <TOintervencoes modulo="tointervencoes" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="tooutrosDados" />
            <TOoutrosDados modulo="tooutrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/RECOMENDAÇÕES/NOTIFICAÇÕES" modulo="toorientacoes" />
            <TOorientacoes modulo="toorientacoes" />
        </>
    )
}

export default Hospital